<template>
    <div class="careersPortalTable" v-if="jobItems.length > 0">
        <div class="careersPortalTable__header">
            <h2 class="careersPortalTable__title">
                Find your perfect job
            </h2>

            <div class="careersPortalTable__subtitle" v-if="subtitle.length > 0">
                {{ subtitle }}
            </div>
        </div>

        <form class="careersPortalTable__filters" @submit.prevent="search">
            <div class="careersPortalTable__filterWrap selectWrap">
                <label class="sr-only" for="title">Select job</label>

                <select class="selectWrap__select" name="title" v-model="selectedTitle">
                    <option value="">Select job</option>
                    <option v-for="title in titles" :value="title">{{ title }}</option>
                </select>
            </div>

            <div class="careersPortalTable__filterWrap selectWrap">
                <label class="sr-only" for="location">Select location</label>

                <select class="selectWrap__select" name="location" v-model="selectedLocation">
                    <option value="">Select location</option>
                    <option v-for="location in locations" :value="location">{{ location }}</option>
                </select>
            </div>

            <div class="careersPortalTable__filterWrap selectWrap">
                <label class="sr-only" for="location">Full time / Part time</label>

                <select class="selectWrap__select" name="type" v-model="selectedType">
                    <option value="">Full time / Part time</option>
                    <option v-for="type in types" :value="type">{{ type }}</option>
                </select>
            </div>

            <button class="careersPortalTable__searchButton careersPortalButton" type="submit">
                Search
            </button>
        </form>

        <table class="careersPortalTable__table">
            <thead class="careersPortalTable__tableHeader">
                <tr>
                    <th class="careersPortalTable__tableCell careersPortalTable__tableCell--header">
                        Job
                    </th>

                    <th class="careersPortalTable__tableCell careersPortalTable__tableCell--header">
                        Brand
                    </th>

                    <th class="careersPortalTable__tableCell careersPortalTable__tableCell--header">
                        Location    
                    </th>

                    <th class="careersPortalTable__tableCell careersPortalTable__tableCell--header">
                        Full time / Part time
                    </th>

                    <th class="careersPortalTable__tableCell careersPortalTable__tableCell--header"></th>
                </tr>
            </thead>

            <tbody>
                <tr class="careersPortalTable__tableRow" v-for="job in filteredJobs">
                    <td class="careersPortalTable__tableCell careersPortalTable__tableCell--data">{{ job.title }}</td>
                    <td class="careersPortalTable__tableCell careersPortalTable__tableCell--data">{{ job.brand }}</td>
                    <td class="careersPortalTable__tableCell careersPortalTable__tableCell--data">{{ job.location }}</td>
                    <td class="careersPortalTable__tableCell careersPortalTable__tableCell--data">{{ job.type }}</td>
                    <td class="careersPortalTable__tableCell careersPortalTable__tableCell--data careersPortalTable__tableCell--alignRight">
                        <a class="careersPortalTable__tableLink" :href="job.link" target="_blank">
                            Find out more
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="careersPortalTable__cards js_careersSlider swiper">
            <div class="swiper-wrapper">
                <div class="careersPortalTable__card careerCard careerCard--borderRight swiper-slide" v-for="job in filteredJobs">
                    <h3 class="careerCard__title">
                        {{ job.title }}
                    </h3>

                    <h4 class="careerCard__subtitle">
                        {{ job.brand }}
                    </h4>

                    <div class="careerCard__meta">
                        <div class="careerCard__metaItem careerCard__metaItem--noLink js_careersFilterButton"
                             data-for-filter-name="location_id"
                             >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><path d="M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272zm-80-272c0-44.183 35.817-80 80-80s80 35.817 80 80-35.817 80-80 80-80-35.817-80-80z"/></svg>

                            <span>
                                {{ job.location }}
                            </span>
                        </div>

                        <div class="careerCard__metaItem careerCard__metaItem--noLink js_careersFilterButton"
                             data-for-filter-name="hours_id"
                             >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"/></svg>

                            <span>
                                {{ job.type }}
                            </span>
                        </div>
                    </div>

                    <div class="careerCard__buttonGroup">
                        <a :href="job.link" class="careerCard__button">Apply</a>
                    </div>
                </div>
            </div>

            <div class="careersPortalTable__pagination swiper-pagination"></div>
        </div>

        <a class="careersPortalTable__footerLink" href="https://petervardy-career.talent-soft.com/accueil.aspx?LCID=2057">View all Jobs</a>
    </div>
</template>

<script>
import SwiperCore, { Pagination } from 'swiper';
SwiperCore.use([Pagination]);

export default {
    props: {
        jobItems: {
            type: [Array, Object],
            default: [],
        },
    },
    data() {
        return {
            selectedTitle: '',
            selectedType: '',
            selectedLocation: '',
            filteredJobs: [],
            swiper: null,
        };
    },
    created() {
        this.jobItems = this.shuffle(this.jobItems);
        this.search();
    },
    mounted() {
        const vm = this;

        setTimeout(function() {
            const options = {
                watchOverflow: true,
                watchSlidesProgress: true,
                freeMode: true,
                slidesPerView: 'auto',
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            };

            vm.swiper = new SwiperCore('.js_careersSlider', options);
        }, 1000);
    },
    methods: {
        filterUnique(jobItems, attribute) {
            const values = jobItems.map(item => item[attribute]);

            return [...new Set(values)];
        },
        search() {
            this.filteredJobs = this.jobItems.filter(this.jobMatchesSelectedLocation)
                                             .filter(this.jobMatchesSelectedType)
                                             .filter(this.jobMatchesSelectedTitle)
                                             .slice(0, 10);

            if (this.swiper) {
                const vm = this;

                setTimeout(function() {
                        vm.swiper.update();
                }, 1000);
            }
        },
        emptyOrMatches(str1, str2) {

            return str1 === '' || str2 === '' || str1 === str2;
        },
        jobMatchesSelectedLocation(job) {

            return this.emptyOrMatches(job.location, this.selectedLocation);
        },
        jobMatchesSelectedType(job) {

            return this.emptyOrMatches(job.type, this.selectedType);
        },
        jobMatchesSelectedTitle(job) {

            return this.emptyOrMatches(job.title, this.selectedTitle);
        },
        shuffle(arr) {
            return arr.map(value => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value);
        },
    },
    computed: {
        locations() {
            return this.filterUnique(this.jobItems, 'location').sort();
        },
        types() {
            return this.filterUnique(this.jobItems, 'type').sort();
        },
        titles() {
            return this.filterUnique(this.jobItems, 'title').sort();
        },
        subtitle() {
            let text = '';

            if (this.jobItems.length > 10) {
                text = `Search from over ${this.jobItems.length} jobs`;
            }

            if (this.locations.length > 1) {
                text = `${text} in ${this.locations.length} locations`;
            }

            return text;
        }
    },
};
</script>
